// extracted by mini-css-extract-plugin
module.exports = {"item":"FailedPrintTableRow_item__16Jch","cell":"FailedPrintTableRow_cell__PWkLE"};